var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"commonArrow",class:{
    grey: _vm.setColor === 'grey',
    white: _vm.setColor === 'white',
    orange: _vm.setColor === 'orange',
    left: _vm.setDirection === 'left',
    sm: _vm.size === 'sm'
  }})
}
var staticRenderFns = []

export { render, staticRenderFns }